import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskEgn'
})
export class MaskEgnPipe implements PipeTransform {
  transform(value: string): string {
    if (!value || value.length < 8) {
      return value; // Ако ЕГН е твърде късо, не го маскираме
    }
    return value.substring(0, 4) + '****' + value.substring(8);
  }

}
